import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
// import {
//   // Cashin,
//   // Cashout,
//   // Customers,
//   // Dashboard,
//    Login,
//   Navbar,
//   // OrderDone,
//   // Orders,
//   // ProductCo,
//   // ReturnOrder,
//   Session,
//   UserProfile,
// } from "./Components/index";

import { useSelector } from "react-redux";

// import LoginPage from "./";
import Login from "./app/login/Login";
import Orderpage from "./app/orders/Orders";
import Deliverypartners from "./components/EordersDeliveryPartners/Deliverypartners";
import Navbar from "./components/Navbar/Navbar";
import ForgotPassword from "./app/forgot-password/ForgotPassword";
import SignupForm from "./app/signup/signupForm";
import Signup from "./app/signup/Signup";
import Mysubscription from "./app/mysubscription/Mysubscription";
import DeliveryPartner from "./app/deliverypartner/DeliveryPartner";
import Dashboard from "./app/dashboard/dashboard";
import Orderlist from "./app/Orderlist/Orderlist";
import UserRegistration from "./app/register/register";
import ProductRequest from "./app/inventory/ProductRequest/ProductRequest";
import InventoryOnboard from "./app/inventory/InventoryOnboard/InventoryOnboard";
import Profile from "./app/settings/profile/Profile";
import Setting from "./app/settings/usermanagement/Setting";
import Sidebar from "./components/SideBar/sidebar";
import Inventory from "./app/inventory/Inventory/inventory";
import Bdo from "./app/settings/Bdo/Bdo";
import shippingCost from "./app/settings/shippingCost/shippingCost";
import "./styles.css";
import ShippingCost from "./app/settings/shippingCost/shippingCost";
import Deposited from "./components/EordersDeliveryPartners/Deposited";
import DeliveryBoyOrders from "./components/EordersDeliveryPartners/DeliveryBoyOrders";
import SessionHistory from "./app/SessionHistory/sessionHistory";
import AddBill from "./app/purchase/addBill";
import SupplyPayment from "./app/purchase/SupplyPayment";
import PurchaseList from "./app/purchase/PurchaseList";
import PurchaseOrder from "./app/purchase/PurchaseOrder";
import Cashback from "./components/Cashback/Cashback";
import InventoryTileData from "./components/Inventory/InventoryTileDetails";
import StockOut from "./components/Inventory/HeaderComponents/StockOut";
import TransactionSummary from "./components/PaymentSettlement/TransactionSummary";
import SettlementReport from "./components/PaymentSettlement/SettlementReport";
import ProductInfo from "./components/Inventory/ProductInfo";
import AllVendors from "./app/purchase/AllVendors";
import VendorInfo from "./app/purchase/VendorInfo";
import BasicCashierSettings from "./components/CashierSetup/BasicCashierSettings";
import CashierModulesAccess from "./components/CashierSetup/CashierModulesAccess";
import CreditHistory from "./app/SessionHistory/CreditHistory";
import CashierSetupScreen from "./app/settings/CashierSetup/CashierSetupScreen";
import CashiInOutReport from "./app/SessionHistory/CashInOutReport";
import OnboardingData from "./app/dashboard/OnboardingData";
import BulkUploadHistory from "./app/settings/BulkUploadHistory";
import LandingPage from "./app/landingPage/landing";
import PosOrders from "./app/SessionHistory/PosOrders";
import PosSaleSummary from "./app/SessionHistory/PosSaleSummary";
import ExpenseManagement from "./components/Setting/ExpenseManagement";
import { getUserOnboarding } from "./API  Functions/DashboardFunctions";
import ExpenseTracker from "./components/Setting/ExpenseMgmt";
import PosDashboard from "./app/dashboard/Posdashbord";
import StockTransfer from "./app/subStore/stockTransfer";
import StockTransferHistory from "./app/subStore/stockTransferHistory";
import Subscription from "./components/Setting/Subscription";
import RenewPlan from "./components/Setting/RenewPlan";
import ItemWiseSale from "./app/SessionHistory/ItemWiseSale";
import InventorySaleSummary from "./app/inventory/InventorySaleSummary/InventorySaleSummary";
import AccountingDashboard from "./app/dashboard/accountingDashboard";
import ProductExpiry from "./components/Inventory/ProductExpiry";
import UserAccessManagement from "./components/Setting/UserAccessManagemnt";
import CategoryWiseSaleSummary from "./app/SessionHistory/CategoryWiseSaleSummary/CategoryWiseSaleSummary";
import CustomerCreditOrderTable from "./app/SessionHistory/CustomerCreditOrderTable";
import CustomerCreditOrder from "./app/SessionHistory/CustomerCreditOrder";
import AllSubStore from "./app/subStore/allSubStore";
import CreateSubStore from "./app/subStore/createSubStore";
import MoneyTransfer from "./components/Accounting/moneyTransfer";
import SubscriptionRedirect from "./components/Setting/SubscriptionRedirect";
import CashierLandingPage from "./app/landingPage/cashierLanding";
import CashierThankyou from "./app/landingPage/thankyou";
import ProductGroups from "./app/ProductGroup/ProductGroup";
import CashierReports from "./components/CashierReports/cashierReports";
import CashierSalesReports from "./components/CashierReports/cashierReports";
import AllWarehouses from "./components/Warehouse/AllWarehouses";
import VatProductsScreen from "./components/Setting/VatProductsScreen";
import AllHampers from "./app/SessionHistory/AllHampers";
import PriceChecker from "./app/priceChecker/PriceChecker";
import AllSalesman from "./app/settings/Salesman/AllSalesman";
import SalesmanReport from "./app/settings/Salesman/SalesmanReport";
import AllCustomers from "./app/SessionHistory/AllCustomers";
import Herosection from "./app/landingPage/HeroSection";
import { useTranslation } from "react-i18next";
import AboutUs from "./app/landingPage/AboutUs";
import NewAllCustomers from "./app/SessionHistory/NewAllCustomers";
import WeightBarcodePage from "./app/LooseBarocde";
import Promotions from "./app/Promotions/Promotions";
import InventoryValidation from "./app/inventoryValidation/InventoryValidation";
import StockAdjustmentPage from "./app/inventoryValidation/StockAdjustmentPage";
import CashierOffers from "./app/Promotions/CashierOffers";
import AllDeliveryBoy from "./app/settings/DeliveryBoy/AllDeliveryBoy"
import DeliveryBoy from "./app/settings/DeliveryBoy/DeliveryBoy";
import { NavbarProvider } from "./context/NavbarContext";
// import CashierModuleAccess from "./app/purchase/CashierModuleAccess";

// Import components or containers for each route

export const routes = {
  home: "/",
  login: "/login",
  aboutus:"/aboutus",
  internalTeamLogin: "/teamlogin",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  orders: "/orders",
  register: "/register",
  cashierlandingPage: "/cashier-pos-egypt",
  pricechecker: "/pricechecker",
  thankyou: "/thankyou",
  accounting: {
    accountingDashboard: "/accounting/dashboard",
    customerCreditOrder: "/customerCreditOrder",
    moneyTransfer: "/accounting/moneyTransfer",
  },
  settings: {
    userManagement: "/settings/usermanagement",
    shippingCost: "/settings/shippingcost",
    profile: "/settings/profile",
    bdo: "/settings/bdo",
    cashiersetup: "/settings/cashiersetup",
    bulkupdatehistory: "/settings/bulkupdatehistory",
    cashboxledger: "/settings/cashboxledger",
    expense: "/settings/expense",
    userAccess: "/settings/userAccess",
    // renewsubscription: "/settings/renewsubscription",
    subscription: "/settings/subscription",
    renewsubscription: "/settings/renewsubscription",
    subscriptionredirect: "/settings/subscriptionredirect",
    vatproductsscreen: "/settings/taxes",
    salesman: "/settings/salesman",
    delivery:"/settings/delivery"
  },
  orderlist: "/Orderlist",
  inventory: {
    root: "/inventory",
    // highOnInventory: "/inventory/Highoninventory",
    // lowOnInventory: "/inventory/Lowoninventory",
    // outOfStock: "/inventory/Outofstock",
    inventoryOnboard: "/inventory/InventoryOnboard",
    productRequest: "/inventory/ProductRequest",
    inventoryProdData: "/inventory/productData",
    productInfo: "/productdetails",
    inventorysalesummary: "/inventory/inventorysalesummary",
    productExpiry: "/inventory/ProductExpiry",
    inventoryVerification: "/inventory/inventoryverification",
    stockAdjustment:'/inventory/stockAdjustment'
  },
  purchase: {
    addBill: "/purchase/add-bill",
    supplyPayment: "/purchase/supplyPayment",
    purchaseList: "/purchase/list",
    purchaseOrder: "/purchase/list/order",
    vendors: "/purchase/vendors",
    vendorInfo: "/vendorDetails",
  },
  paymentsettlement: {
    settlementreport: "/paymentsettlement/settlementreport",
    transactionsummary: "/paymentsettlement/transactionsummary",
  },
  substore: {
    stockTransfer: "/substore/stocktransfer",
    stockTransferHistory: "/substore/stocktransferhistory",
    allSubstore: "/substore/list",
    createSubstore: "/substore/createSubstore",
  },
  warehouse: {
    allwarehouse: "/warehouse/list",
  },
  cashier: {
    itemWiseSale: "/pos/ItemWiseSale",
    CategoryWiseSale: "/pos/CategoryWiseSale",
    productGroup: "/pos/productGroups",
    cashierReports: "/pos/reports",
    hampers: "/pos/hampers",
    allcustomers: "/pos/allcustomers",
    promotions: "/pos/bulkdiscount",
    cashieroffers:"/pos/promotion"
  },
  cashback: "/cashback",
  onboarding: "/onboarding",
  dashboard: "/dashboard",
  // posdashboard: "/posdashboard",
  deliveryPartner: "/deliverypartner",
  deliveryPartnerOrder: "/deliveryPartner/Order",
  mySubscription: "/mysubscription",
  sessionHistory: "/pos/sessionHistory",
  credithistory: "/pos/credithistory",
  cashinoutreport: "/pos/cashinoutreport",
  posOrders: "pos/orders",
  posSaleSummary: "pos/salesummary",
  newCustomersTable: "/newcustomertable",
  loosebarcodegenerator: "/loosebarcodegenerator",
};

const PrivateLayout = () => {
  const { user } = useSelector((state) => state?.login);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { i18n } = useTranslation();
  if (!user?.result?.access_token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <NavbarProvider>
      <div className="flex" style={{ width: "100vw", height: "100vh" }}>
        <Sidebar
          mobileOpen={isMobileSidebarOpen}
          onMobileClose={() => setIsMobileSidebarOpen(false)}
        />
        <div className="relative w-full overflow-y-auto custom-scrollbar bg-[#FFFFFF]">
          <button
            type="button"
            onClick={() => setIsMobileSidebarOpen(true)}
            className={`fixed top-3 z-30 rounded-md bg-primaryBlue px-3 py-2 text-white shadow-md md:hidden ${
              i18n.language === "ar" ? "right-3" : "left-3"
            }`}
            aria-label="Open menu"
          >
            ☰
          </button>
          <Navbar />
          <div className="pt-14 md:pt-0">
            <Outlet />
          </div>
        </div>
      </div>
    </NavbarProvider>
  );
};

const LoginExist = ({ children }) => {
  const { user } = useSelector((state) => state?.login);
  const [onboardingDone, setOnboardingDone] = useState(null); // null = loading

  const CheckUserOnboarding = async (company_id) => {
    try {
      const res1 = await getUserOnboarding(company_id);
      if (res1?.result[0]?.status_code === 200) {
        let keys = res1?.result[0];

        return (
          keys?.update_inventory &&
          keys?.cashier_setup &&
          keys?.weighing_scale &&
          keys?.add_user &&
          keys?.delivery_company
        );
      }
      return false;
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      return false;
    }
  };

  useEffect(() => {
    const fetchOnboarding = async () => {
      if (user?.result?.company_id) {
        const result = await CheckUserOnboarding(user?.result?.company_id);
        setOnboardingDone(result);
      }
    };
    if (user) {
      fetchOnboarding();
    }
  }, [user]);

  // if no user → just show children (login page etc.)
  if (!user) {
    return children;
  }

  // while onboarding status is loading → show loader
  if (onboardingDone === null) {
    return <div>Loading...</div>;
  }

  // navigate based on onboarding check

  const is_retailer = user?.result?.is_retailer;

  return is_retailer === false ? (
    <Navigate to="/orders" replace />
  ) : onboardingDone ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/onboarding" replace />
  );
};

const ProjectRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route
          path={routes.home}
          element={
            // <LoginExist>
            //   <Login />
            // </LoginExist>
            <Herosection />
            // <LandingPage />
          }
        />
        <Route
          path={routes.aboutus}
          element={
           <AboutUs/>
          }
        />
        <Route
          path={routes.cashierlandingPage}
          element={
            // <LoginExist>
            //   <Login />
            // </LoginExist>
            <CashierLandingPage />
          }
        />
        <Route path={routes.thankyou} element={<CashierThankyou />} />
        <Route
          path={routes.login}
          element={
            <LoginExist>
              <Login />
            </LoginExist>
          }
        />
        <Route
          path={routes.internalTeamLogin}
          element={
            <LoginExist>
              <Login />
            </LoginExist>
          }
        />
        <Route path={routes.signup} element={<Signup />} />
        <Route
          path={routes.forgotPassword}
          element={
            <LoginExist>
              <ForgotPassword />
            </LoginExist>
          }
        />
        <Route
          path={routes.register}
          element={
            // <LoginExist>
            <UserRegistration />
            // </LoginExist>
          }
        />
        <Route
          path={routes.settings.subscriptionredirect}
          element={<SubscriptionRedirect />}
        />
        <Route
          path={routes.pricechecker}
          element={
            // <LoginExist>
            //   <Login />
            // </LoginExist>
            <PriceChecker />
          }
        />
        <Route
          path={routes.loosebarcodegenerator}
          element={
            // <PrivateRoute>
              <WeightBarcodePage />
            // </PrivateRoute>
          }
        />

        {/* Private routes: share one Sidebar/Navbar layout so they persist across navigation */}
        <Route element={<PrivateLayout />}>
          {/* Nested Routing for Settings */}
          <Route path={routes.settings.userManagement} element={<Setting />} />
          <Route path={routes.settings.shippingCost} element={<ShippingCost />} />
          <Route path={routes.settings.profile} element={<Profile />} />
          <Route path={routes.settings.bdo} element={<Bdo />} />

          {/* Add more nested routes for settings as needed */}

          {/* Nested Routing for Inventory */}
          <Route path={routes.inventory.root} element={<Inventory />} />
          {/* <Route path={routes.inventory.highOnInventory} element={<HighOnInventory />} />
          <Route path={routes.inventory.lowOnInventory} element={<LowOnInventory />} />
          <Route path={routes.inventory.outOfStock} element={<StockOut />} /> */}
          <Route path={routes.inventory.inventoryOnboard} element={<InventoryOnboard />} />
          <Route path={routes.inventory.productRequest} element={<ProductRequest />} />
          <Route path={routes.inventory.inventorysalesummary} element={<InventorySaleSummary />} />
          <Route path={routes.inventory.productInfo} element={<ProductInfo />} />
          {/* Add more nested routes for inventory as needed */}

          {/* Other routes */}
          <Route path={routes.orders} element={<Orderpage />} />
          <Route path={routes.orderlist} element={<Orderlist />} />
          <Route path={routes.dashboard} element={<Dashboard />} />
          <Route path={routes.onboarding} element={<OnboardingData />} />
          <Route path={routes.deliveryPartner} element={<DeliveryPartner />} />
          <Route path={routes.deliveryPartnerOrder} element={<DeliveryBoyOrders />} />
          <Route path={routes.mySubscription} element={<Mysubscription />} />
          <Route path={routes.purchase.addBill} element={<AddBill />} />
          <Route path={routes.purchase.supplyPayment} element={<SupplyPayment />} />
          <Route path={routes.purchase.purchaseList} element={<PurchaseList />} />
          <Route path={routes.purchase.purchaseOrder} element={<PurchaseOrder />} />
          <Route path={routes.purchase.vendors} element={<AllVendors />} />
          <Route path={routes.purchase.vendorInfo} element={<VendorInfo />} />
          <Route path={routes.sessionHistory} element={<SessionHistory />} />
          <Route path={routes.cashback} element={<Cashback />} />
          <Route path={routes.paymentsettlement.transactionsummary} element={<TransactionSummary />} />
          <Route path={routes.paymentsettlement.settlementreport} element={<SettlementReport />} />
          <Route path={routes.credithistory} element={<CreditHistory />} />
          <Route path={routes.cashinoutreport} element={<CashiInOutReport />} />
          <Route path={routes.posOrders} element={<PosOrders />} />
          <Route path={routes.posSaleSummary} element={<PosSaleSummary />} />
          <Route path={routes.settings.cashiersetup} element={<CashierSetupScreen />} />
          <Route path={routes.settings.bulkupdatehistory} element={<BulkUploadHistory />} />
          <Route path={routes.settings.cashboxledger} element={<ExpenseManagement />} />
          <Route path={routes.settings.expense} element={<ExpenseTracker />} />
          <Route path={routes.posdashboard} element={<PosDashboard />} />
          <Route path={routes.substore.stockTransfer} element={<StockTransfer />} />
          <Route path={routes.substore.stockTransferHistory} element={<StockTransferHistory />} />
          <Route path={routes.settings.subscription} element={<Subscription />} />
          <Route path={routes.settings.renewsubscription} element={<RenewPlan />} />
          <Route path={routes.cashier.itemWiseSale} element={<ItemWiseSale />} />
          <Route path={routes.accounting.accountingDashboard} element={<AccountingDashboard />} />
          <Route path={routes.inventory.productExpiry} element={<ProductExpiry />} />
          <Route path={routes.settings.userAccess} element={<UserAccessManagement />} />
          <Route path={routes.cashier.CategoryWiseSale} element={<CategoryWiseSaleSummary />} />
          <Route path={routes.accounting.customerCreditOrder} element={<CustomerCreditOrder />} />
          <Route path={routes.substore.allSubstore} element={<AllSubStore />} />
          <Route path={routes.substore.createSubstore} element={<CreateSubStore />} />
          <Route path={routes.accounting.moneyTransfer} element={<MoneyTransfer />} />
          <Route path={routes.cashier.allcustomers} element={<AllCustomers />} />
          <Route path={routes.cashier.productGroup} element={<ProductGroups />} />
          <Route path={routes.cashier.cashierReports} element={<CashierSalesReports />} />
          <Route path={routes.warehouse.allwarehouse} element={<AllWarehouses />} />
          <Route path={routes.settings.vatproductsscreen} element={<VatProductsScreen />} />
          <Route path={routes.cashier.hampers} element={<AllHampers />} />
          <Route path={routes.settings.salesman} element={<AllSalesman />} />
          <Route path={routes.settings.delivery} element={<DeliveryBoy />} />
          <Route path={routes.newCustomersTable} element={<NewAllCustomers />} />
          <Route path={routes.cashier.promotions} element={<Promotions />} />
          <Route path={routes.cashier.cashieroffers} element={<CashierOffers />} />
          <Route path={routes.inventory.inventoryVerification} element={<InventoryValidation />} />
          <Route path={routes.inventory.stockAdjustment} element={<StockAdjustmentPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default ProjectRoutes;
